import { render, staticRenderFns } from "./ListFormModalFisico.vue?vue&type=template&id=e87a7afc"
import script from "./ListFormModalFisico.vue?vue&type=script&lang=js"
export * from "./ListFormModalFisico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports